import React, { useState } from 'react';
import { generisiPDFServer } from './PlatePDFLogic';

const PlateTableSuma = ({ tabelaDana = {}, radnikObj = {} }) => {
    
    // 1. Lokalni state za ručne unose (Bonus, Odbici, itd.)
    const [bonusKolicina, setBonusKolicina] = useState(0);
    const [bonusCena, setBonusCena] = useState(0);
    const [dnevniceKolicina, setDnevniceKolicina] = useState(0);
    const [isplataZiro, setIsplataZiro] = useState(0);
    const [ostaliOdbici, setOstaliOdbici] = useState(0);

    // 2. Stilovi za tabelu (Dark Theme)
    const thStyle = { 
        padding: '8px', 
        border: '1px solid #1a2a4a', 
        color: '#3366ff', 
        textAlign: 'left', 
        backgroundColor: '#162447', 
        fontSize: '14px' 
    };
    
    const tdStyle = { 
        padding: '8px', 
        border: '1px solid #1a2a4a', 
        color: 'white', 
        fontSize: '14px' 
    };
    
    const inputStyle = { 
        width: '80px', 
        backgroundColor: '#050a1a', 
        color: 'white', 
        border: '1px solid #3366ff', 
        padding: '3px', 
        borderRadius: '4px', 
        textAlign: 'center' 
    };
    
    const totalRowStyle = { 
        fontWeight: 'bold', 
        backgroundColor: '#162447' 
    };

    // 3. Pomoćne funkcije za proračun vremena
    const decimalToTime = (decimal) => {
        if (!decimal || decimal <= 0) return "00:00";
        const hrs = Math.floor(decimal);
        const mins = Math.round((decimal - hrs) * 60);
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    };

    const parseTimeToDecimal = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours + (minutes / 60);
    };

    // 4. Glavna matematika (Sabiranje sati i statusa)
    const daniNiz = Object.values(tabelaDana);

    const ukupnoRedovnoDec = daniNiz.reduce((sum, d) => sum + parseTimeToDecimal(d.redovno), 0);
    
    const ukupnoPrekovremenoDec = daniNiz.reduce((sum, d) => sum + parseTimeToDecimal(d.prekovremeno), 0);
    
    let brojStandardnihTO = 0;
    let brojDodatnihTO = 0;
    
    daniNiz.forEach(d => {
        const ukupnoSatiNaPoslu = parseTimeToDecimal(d.ukupno);
        if (ukupnoSatiNaPoslu > 0) {
            brojStandardnihTO += 1;
            if (ukupnoSatiNaPoslu > 15.5) {
                brojDodatnihTO += 2;
            } else if (ukupnoSatiNaPoslu > 9.5) {
                brojDodatnihTO += 1;
            }
        }
    });

    const brojTerenskihDodataka = daniNiz.filter(d => d.teren_dodatak === 'da').length;
    
    const bolovanjeDani = daniNiz.filter(d => d.status === 'Bolovanje').length;
    
    const odmorDani = daniNiz.filter(d => d.status === 'Odmor').length;
    
    const praznikDani = daniNiz.filter(d => d.status === 'Praznik').length;
    
    const krsnaSlavaDani = daniNiz.filter(d => d.status === 'Krsna slava').length;

    // 5. Dohvatanje cena iz radnikObj
    const cRedovan = parseFloat(radnikObj?.cena_redovnog_sata) || 0;
    const cPrekovremeno = parseFloat(radnikObj?.cena_prekovremenog_sata) || 0;
    const cTopli = parseFloat(radnikObj?.cena_toplog_obroka) || 0;
    const cTopliDodatni = parseFloat(radnikObj?.cena_toplog_obroka_dodatni) || 0;
    const cBolovanje = parseFloat(radnikObj?.cena_bolovanja) || 0;
    const cOdmor = parseFloat(radnikObj?.cena_odmora) || 0;
    const cPraznik = parseFloat(radnikObj?.cena_praznika) || 0;
    const cTerenskiDodatak = parseFloat(radnikObj?.cena_terenskog_dodatka) || 0;
    const cTerenskaDnevnica = parseFloat(radnikObj?.cena_terenske_dnevnice) || 0;

    // 6. Računanje finalnih iznosa
    const iznosRedovno = ukupnoRedovnoDec * cRedovan;
    const iznosPrekovremeno = ukupnoPrekovremenoDec * cPrekovremeno;
    const iznosTopli = brojStandardnihTO * cTopli;
    const iznosTopliDodatni = brojDodatnihTO * cTopliDodatni;
    const iznosBolovanje = bolovanjeDani * cBolovanje;
    const iznosOdmor = odmorDani * cOdmor;
    const iznosPraznik = praznikDani * cPraznik;
    const iznosKrsnaSlava = krsnaSlavaDani * cPraznik;
    const iznosTerenskiDodatak = brojTerenskihDodataka * cTerenskiDodatak;
    
    const iznosBonus = bonusKolicina * bonusCena;
    const iznosTerenskaDnevnica = dnevniceKolicina * cTerenskaDnevnica;

    const ukupnoBruto = iznosRedovno + iznosPrekovremeno + iznosTopli + iznosTopliDodatni + 
                       iznosBolovanje + iznosOdmor + iznosPraznik + iznosKrsnaSlava + 
                       iznosTerenskiDodatak + iznosBonus;

    const ukupnoZaIsplatu = ukupnoBruto - isplataZiro - iznosTerenskaDnevnica - ostaliOdbici;

    // 7. Funkcija koja pakuje podatke i poziva eksternu PDF logiku
    const handleGenerisiPDF = () => {
        const obracunPodaci = {
            stavke: [
                { naziv: "Radnih sati (Redovno)", kolicina: decimalToTime(ukupnoRedovnoDec), cena: cRedovan.toFixed(2), iznos: iznosRedovno.toFixed(2) },
                { naziv: "Radnih sati (Prekovremeno)", kolicina: decimalToTime(ukupnoPrekovremenoDec), cena: cPrekovremeno.toFixed(2), iznos: iznosPrekovremeno.toFixed(2) },
                { naziv: "Topli obrok", kolicina: brojStandardnihTO, cena: cTopli.toFixed(2), iznos: iznosTopli.toFixed(2) },
                { naziv: "Topli obrok dodatni", kolicina: brojDodatnihTO, cena: cTopliDodatni.toFixed(2), iznos: iznosTopliDodatni.toFixed(2) },
                { naziv: "Terenski dodatak", kolicina: brojTerenskihDodataka, cena: cTerenskiDodatak.toFixed(2), iznos: iznosTerenskiDodatak.toFixed(2) },
                { naziv: "Bolovanje", kolicina: bolovanjeDani, cena: cBolovanje.toFixed(2), iznos: iznosBolovanje.toFixed(2) },
                { naziv: "Godišnji odmor", kolicina: odmorDani, cena: cOdmor.toFixed(2), iznos: iznosOdmor.toFixed(2) },
                { naziv: "Državni praznik", kolicina: praznikDani, cena: cPraznik.toFixed(2), iznos: iznosPraznik.toFixed(2) },
                { naziv: "Krsna slava", kolicina: krsnaSlavaDani, cena: cPraznik.toFixed(2), iznos: iznosKrsnaSlava.toFixed(2) },
                { naziv: "Bonus", kolicina: bonusKolicina, cena: bonusCena.toFixed(2), iznos: iznosBonus.toFixed(2) }
            ],
            odbici: [
                { naziv: "Isplaćeno na tekući račun", iznos: isplataZiro.toFixed(2) },
                { naziv: "Isplaćeno terenskih dnevnica", kolicina: dnevniceKolicina, cena: cTerenskaDnevnica.toFixed(2), iznos: iznosTerenskaDnevnica.toFixed(2) },
                { naziv: "Ostali odbici", iznos: ostaliOdbici.toFixed(2) }
            ],
            ukupno_bruto: ukupnoBruto.toFixed(2),
            ukupno_neto: ukupnoZaIsplatu.toFixed(2)
        };

        generisiPDFServer(tabelaDana, radnikObj, obracunPodaci);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', marginTop: '30px' }}>
            
            <button 
                onClick={handleGenerisiPDF} 
                style={{ marginBottom: '10px', alignSelf: 'flex-end', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
            >
                Preuzmi PDF
            </button>

            <div style={{ width: '100%', padding: '15px', backgroundColor: '#0a132b', borderRadius: '8px', border: '1px solid #1a2a4a' }}>
                
                <h3 style={{ color: '#3366ff', marginBottom: '10px', fontSize: '18px' }}>
                    Finansijski Obračun: {radnikObj?.ime || ''} {radnikObj?.prezime || ''}
                </h3>
                
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Naziv stavke</th>
                            <th style={thStyle}>Količina</th>
                            <th style={thStyle}>Cena</th>
                            <th style={thStyle}>Iznos (RSD)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td style={tdStyle}>Radnih sati (Redovno)</td><td style={tdStyle}>{decimalToTime(ukupnoRedovnoDec)}</td><td style={tdStyle}>{cRedovan.toFixed(2)}</td><td style={tdStyle}>{iznosRedovno.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Radnih sati (Prekovremeno)</td><td style={tdStyle}>{decimalToTime(ukupnoPrekovremenoDec)}</td><td style={tdStyle}>{cPrekovremeno.toFixed(2)}</td><td style={tdStyle}>{iznosPrekovremeno.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Topli obrok</td><td style={tdStyle}>{brojStandardnihTO}</td><td style={tdStyle}>{cTopli.toFixed(2)}</td><td style={tdStyle}>{iznosTopli.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Topli obrok dodatni</td><td style={tdStyle}>{brojDodatnihTO}</td><td style={tdStyle}>{cTopliDodatni.toFixed(2)}</td><td style={tdStyle}>{iznosTopliDodatni.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Terenski dodatak</td><td style={tdStyle}>{brojTerenskihDodataka}</td><td style={tdStyle}>{cTerenskiDodatak.toFixed(2)}</td><td style={tdStyle}>{iznosTerenskiDodatak.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Bolovanje</td><td style={tdStyle}>{bolovanjeDani}</td><td style={tdStyle}>{cBolovanje.toFixed(2)}</td><td style={tdStyle}>{iznosBolovanje.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Godišnji odmor</td><td style={tdStyle}>{odmorDani}</td><td style={tdStyle}>{cOdmor.toFixed(2)}</td><td style={tdStyle}>{iznosOdmor.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Državni praznik</td><td style={tdStyle}>{praznikDani}</td><td style={tdStyle}>{cPraznik.toFixed(2)}</td><td style={tdStyle}>{iznosPraznik.toFixed(2)}</td></tr>
                        <tr><td style={tdStyle}>Krsna slava</td><td style={tdStyle}>{krsnaSlavaDani}</td><td style={tdStyle}>{cPraznik.toFixed(2)}</td><td style={tdStyle}>{iznosKrsnaSlava.toFixed(2)}</td></tr>
                        <tr>
                            <td style={tdStyle}>Bonus</td>
                            <td style={tdStyle}><input type="number" value={bonusKolicina} onChange={(e) => setBonusKolicina(parseFloat(e.target.value) || 0)} style={inputStyle} /></td>
                            <td style={tdStyle}><input type="number" value={bonusCena} onChange={(e) => setBonusCena(parseFloat(e.target.value) || 0)} style={inputStyle} /></td>
                            <td style={tdStyle}>{iznosBonus.toFixed(2)}</td>
                        </tr>
                        <tr style={totalRowStyle}><td style={{ ...tdStyle, color: '#3366ff' }}>UKUPNO ZARADA (BRUTO)</td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}>{ukupnoBruto.toFixed(2)}</td></tr>
                        <tr><td style={{ ...tdStyle, color: '#ff4d4d' }}>Isplaćeno na tekući račun</td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}><input type="number" value={isplataZiro} onChange={(e) => setIsplataZiro(parseFloat(e.target.value) || 0)} style={inputStyle} /></td></tr>
                        <tr>
                            <td style={{ ...tdStyle, color: '#ff4d4d' }}>Isplaćeno terenskih dnevnica</td>
                            <td style={tdStyle}><input type="number" value={dnevniceKolicina} onChange={(e) => setDnevniceKolicina(parseFloat(e.target.value) || 0)} style={inputStyle} /></td>
                            <td style={tdStyle}>{cTerenskaDnevnica.toFixed(2)}</td>
                            <td style={{ ...tdStyle, color: '#ff4d4d' }}>{iznosTerenskaDnevnica.toFixed(2)}</td>
                        </tr>
                        <tr><td style={{ ...tdStyle, color: '#ff4d4d' }}>Ostali odbici</td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}><input type="number" value={ostaliOdbici} onChange={(e) => setOstaliOdbici(parseFloat(e.target.value) || 0)} style={inputStyle} /></td></tr>
                        <tr style={totalRowStyle}>
                            <td style={{ ...tdStyle, color: '#00ff00' }}>ZA ISPLATU (NETO)</td>
                            <td style={tdStyle}></td><td style={tdStyle}></td>
                            <td style={{ ...tdStyle, color: '#00ff00', fontSize: '1.1em' }}>{ukupnoZaIsplatu.toFixed(2)} RSD</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PlateTableSuma;